import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import FiltroPedidosDigitacao from "@/shared/view-models/Filtros/FiltroPedidosDigitacao";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import EVENTS from "@/shared/events/events"

const name = "PedidoEmDigitacao";
export default {
  name,
  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-date-input": gDateInput,
    "g-button": gButton,
    "g-data-table": gDataTable,
  },

  props: {},

  mounted() {
    this.getLogDigitacao()
    this.EmpresaArray = this.$store.state.EmpresaArray;
    this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.formSearch.EmpresaId = this.$store.state.empresaSelecionadaId;
    })
  },

  computed: {},

  updated() {},

  data() {
    return {
        formSearch: {
          UnidadeId: null,
          ClienteId: null,
          DataInicio: null,
          DataFim: null,
          RepresentanteId: null
        },
        mensagemvazio: true,
        popup: false,
        informacaoPedidoSelecionado: null,
        objFiltro: new FiltroPedidosDigitacao(),
        PedidoArray: [],
        EmpresaArray:[],
        dataClientes:[],
        timer: null,

        Colunas: [
            { field: "codigoExtNum", header: "Pedido", width: '100px', ordena: true },
            { field: "numeroOrcamento", header: "Orçamento", width: '140px', ordena: true },
            { field: "dataInclusaoFormatada", header: "Data", width: '200px', ordena: true, ordenacao: 'dataEntregaFormatada' },
            { field: "nomeEmpresa", header: "Unidade", width: '250px', ordena: true },
            { field: "nomeRepresentante", header: "Representante", width: '200px', ordena: true },
            { field: "nomeFantasia", header: "Cliente", width: '200px', ordena: true },
            { field: "nomeProduto", header: "Produto", width: '320px', ordena: true },
            { field: "cv", header: "CV", width: '50px', ordena: true },
        ],

        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroPedido': {value: null, matchMode: this.filtros.CONTAINS},
          'numeroOrcamento': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeFantasia': {value: null, matchMode: this.filtros.CONTAINS},
          'CV': {value: null, matchMode: this.filtros.CONTAINS},
          'dataInclusaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
        },
        popupConfirmarExclusao: false,
        pedidoSelecionadoId: null,
        indexPedidoDeletado: null
    };
  },

  methods: {
    buscar(){
      this.$isLoading(true)
      this.mensagemvazio = false

      //this.PedidosDigitacaoAtivos()
      this.axios({
        method: "get",
        data: this.formSearch,
        url:
          process.env.VUE_APP_WEB_API + "GerarNovoPedido/ExcluiPedidosEmDigitacaoComSequenciaCancelada",
      })
        .then(() => {
        })
        .finally(()=> {
          this.axios({
            method: "post",
            data: this.formSearch,
            url:
              process.env.VUE_APP_WEB_API + "Pedido/GetPedidoEmDigitacao",
          })
            .then((response) => {
              this.PedidoArray = response.data.data ? response.data.data : [];
            })
            .finally(()=> {
              this.$isLoading(false)
            })        })







    },
    modificar() {
      this.continuarPedido(this.informacaoPedidoSelecionado);
    },
    abrePopup(informacaoDaLinha) {
      this.popup = true;
      this.informacaoPedidoSelecionado = informacaoDaLinha;
    },
    fechaPopup() {
      this.popup = false;
    },
    clear() {
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null;
      });
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.getClienteDropDownsByNome(event, this.formSearch.UnidadeId).requisicao
        .then((response)=> {
          if(!this.formSearch.ClienteId){ // se não tiver cliente selecionado
            this.dataClientes = response.data.data;
            return;
          }
          this.dataClientes = this.dataClientes.concat(response.data.data);
        })
      }, 1000);
    },

    // popularDropDownEmpresa(){
    //   this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    //   this.atualizaEmpresaRepresentante()
    //   },

    PedidosDigitacaoAtivos() {
      this.axios({
        method: 'Get',
        url: process.env.VUE_APP_WEB_API +  `Pedido/GetPedidosDigitacao`,
      })
      .then((response) => {
        this.PedidosDigitacaoArray = response.data.data 
      })
      .catch(() => {
      })
    },

    ContinuarPedido(PedidosDigitacaoArray) {
      let PedidoId = PedidosDigitacaoArray.id
      this.$router.push(`/gerar-novo-pedido/${PedidoId}/pedido`)
    },

    redireciona(){
      this.ContinuarPedido(this.informacaoPedidoSelecionado)
    },

    limparFiltro(){
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null;
      });
      EmpresaController.getEmpresasAtivas().requisicao
      .then(
        this.atualizaEmpresaRepresentante()
      );
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },
    continuarPedido(informacaoDaLinha) {
      let PedidoId = informacaoDaLinha.id;
      this.$router.push(`/gerar-novo-pedido/${PedidoId}/info-cliente-pedido`);
      },
      atualizaEmpresaRepresentante(){
        this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
        this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      },
      excluirPedidoDigitacao(data, index) {
        this.popupConfirmarExclusao = true
        this.pedidoSelecionadoId = data.id
        this.indexPedidoDeletado = index;
      },
      fechaPopupExclusao() {
        this.popupConfirmarExclusao = false;
      },

      getLogDigitacao() {
        this.axios ({
          method: "get",
          url: 
            process.env.VUE_APP_WEB_API +
            `Pedido/getLogDigitacao/`
          }).then(() => {
          })
      },
      confirmarExclusaoPedido() {
        this.$isLoading(true)
        PedidoController.DeletarPedidoDigitacao(this.pedidoSelecionadoId).requisicao
        .then(res => {
          if(res.data.data){
            this.$toast.add({ severity: 'success', summary: 'Pedido deletado!', life: 3200 });
            this.popupConfirmarExclusao = false;
            this.PedidoArray.splice(this.indexPedidoDeletado, 1);
            return
          }
          this.$toast.add({ severity: 'error', summary: 'Erro ao deletar pedido', life: 3200 });
           }).finally(()=> {
          this.$isLoading(false)
        })
      },
    }
  };

